module.exports = __webpack_public_path__ + "img/bg_bizhongxiangqing.f3145844.png";